module UserAssignmentTable
{
	const linkTypeAttributeName = "linktype";
	const userIdAttributeName = "userid";
	const departmentIdAttributeName = "departmentid";

	export function construct()
	{
		$(".user-assignments").find("input[type=checkbox]:enabled").change(checkboxChanged);
	}

	function checkboxChanged(event: JQuery.Event<HTMLElement, null>)
	{
		const checkbox = $(event.target);
		const value = checkbox.is(":checked");
		const userID = getUserID(checkbox) as string;
		const linkType = checkbox.data(linkTypeAttributeName) as UserAssignments.LinkTypes;
		const departmentID = DataAttributeTools.DataForElementOrParents(checkbox, departmentIdAttributeName) as string;

		UserAssignments.UpdateAssignment(userID, departmentID, linkType, value, Notifications.ChangeSaved);

		if (value && linkType == UserAssignments.LinkTypes.Assigned || linkType == UserAssignments.LinkTypes.Supervising)
		{
			setCertifiedChecked(checkbox);
		}
	}

	function setCertifiedChecked(checkbox: JQuery<HTMLElement>)
	{
		var certifiedCheckbox = checkbox.parents("tr").find("input[data-linktype=0]");
		certifiedCheckbox.prop("checked", true);
	}

	function getUserID(element: JQuery<HTMLElement>): any
	{
		return element.parents("table").data(userIdAttributeName);
	}
}